import React from 'react';
import {Link} from 'react-router';
import PropTypes from 'prop-types';
import './assets/sign-up-link.scss';

const SignUpLink = (props) => (
  <Link
    onClick={props.toggleMobileMenu}
    data-test-id='sign-up-button'
    className='sign-up-link-button'
    to='/signup'
  >
    Sign Up
  </Link>
);

SignUpLink.propTypes = {
  toggleMobileMenu: PropTypes.func
};

export default SignUpLink;
